import { useParams } from "react-router-dom";

import RundownTemplateFormContainer from "./index";

/**
 * Wrapper component that extracts route params and passes them to the connected RundownTemplateForm container
 * This bridges React Router v6's useParams() hook with the legacy connect() HOC pattern
 */
const RundownTemplateFormWithParams = () => {
	const params = useParams();

	return <RundownTemplateFormContainer params={params} />;
};

export default RundownTemplateFormWithParams;
